import './polyfills/polyfills'
import {createApp} from 'vue'
import App from './App.vue'
import {router} from './router/router'
import store from './store/store'
import '@/assets/app.scss'
import globalFunction from './utils/globalFunction'
import {setLocale} from 'yup'
import {yupLocaleRu} from '@/configs/yupLocale'
import '@/configs/yupValidationMethods.js'
import {fullscreenImagePlugin} from '@/utils/test/fullscreenImagePlugin'
import OneSignalVuePlugin from '@onesignal/onesignal-vue3'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import '@coddicat/vue-pinch-scroll-zoom/style.css'
import './registerServiceWorker'
import {appType, appTypes} from '@/appType/appType.js'
import '@/locales/i18nextInit.js'
import './theme.css'
import {settings} from '@/configs/settings.js'
import directives from '@/directives/directives.js'
import {isAuthRateLimitError} from '@/utils/authApiError.js'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import 'swiper/css'

console.log(appType, settings.env.VUE_APP_VERSION)

if (settings.env.VUE_APP_FPS_COUNTER || localStorage.getItem('VUE_APP_FPS_COUNTER')) {
  import('stats.js/src/Stats').then(({default: Stats}) => {
    const stats = new Stats()
    stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
    stats.dom.style.pointerEvents = 'none'
    stats.dom.style.opacity = '0.7'
    document.body.appendChild(stats.dom)

    function animate() {
      stats.begin()
      stats.end()
      requestAnimationFrame(animate)
    }

    requestAnimationFrame(animate)
  })
}

// const $ = jQuery
// window.$ = $
window.require = (str) => {
  return str.replace('@', '')
}
setLocale(yupLocaleRu)

store.dispatch('user/restore')

const app = createApp(App)

async function initSentry(vueApp) {
  if (!settings.env.VUE_APP_SENTRY_DSN) {
    return
  }

  const Sentry = await import('@sentry/vue')
  const tracePropagationTargets = ['localhost']
  if (settings.env.VUE_APP_SENTRY_PROPAGATION_TARGET) {
    tracePropagationTargets.push(settings.env.VUE_APP_SENTRY_PROPAGATION_TARGET)
  }

  Sentry.init({
    app: vueApp,
    release: settings.env.VUE_APP_VERSION,
    dsn: settings.env.VUE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets,
  })
}

initSentry(app)

const oneSignalAppId = settings.env.VUE_APP_ONE_SIGNAL_APP_ID
if (oneSignalAppId && appType === appTypes.WEB) {
  app.use(OneSignalVuePlugin, {
    appId: oneSignalAppId,
    autoResubscribe: true,
    autoPrompt: true,
    notifyButton: {
      enable: true
    },
    allowLocalhostAsSecureOrigin: true,
  })
}

app
  // .use($)
  .use(VueVirtualScroller)
  .use(fullscreenImagePlugin)
  .use(globalFunction)
  .use(directives)
  .use(store)
  .use(FloatingVue)
  .use(router)
  .mount('#app')

if (!settings.env.VUE_APP_IS_DEVELOPMENT) {
  app.config.errorHandler = async (err, vm, info) => {
    console.log('VueErrorHandler')
    console.error('Error:', err)
    console.error('Vue component:', vm)
    console.error('Additional info:', info)

    if (!isAuthRateLimitError(err)) {
      await store.dispatch('app/setCrashedState', true)
    }

    throw err
  }
}

export {app}
